import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import entityReducer from 'store/saga/entityReducer';

import { appointmentsReducer } from 'features/Appointments';
import { instructorsReducer } from 'features/Instructors';
import { opportunitiesTeaserReducer } from 'features/Opportunities';
import { pike13MigrationReducer } from 'features/Migrate';
import { ratingsReducer } from 'features/Ratings';
import { schedulesReducer } from 'features/Schedules';
import { classtivitySchedulerReducer } from 'features/Schedules/ClasstivityScheduler';
import { sidenavReducer } from 'features/Sidenav';
import classDetailTableReducer from 'features/ClassDetail/ClassDetailTable/ClassDetailTable.reducers';
import statsReducer from 'features/Stats/Stats.reducers';
import reservationsReportReducer from 'features/Stats/Reservations/Reservations.reducers';
import scheduleReportReducer from 'features/Stats/Schedule/Schedule.reducers';
import schedulesReportReducer from 'features/Stats/Schedules/Schedules.reducers';
import venuesReportReducer from 'features/Stats/Venues/Venues.reducers';
import payoutTransactionReducer from 'features/Stats/PayoutTransaction/PayoutTransaction.reducers';
import venuePageReducer from 'features/VenuePage/VenuePage.reducers';
import { yieldManagementReducer } from 'features/YieldManagement';
import { bannerReducer } from 'components/Banner';
import { snackbarReducer } from 'components/Snackbar';
import { modalReducer } from 'components/Modal';
import { reducer as optimizelyReducer } from 'components/Optimizely';
import { excessInventoryReducer } from 'features/Home/modules/ExcessInventory/ExcessInventory.reducers';

import appReducer from './app';
import localeReducer from './locale-data';
import routeReducer from './route';
import uiReducer from './ui';

const rootReducer = combineReducers({
  app: appReducer,
  appointments: appointmentsReducer,
  banner: bannerReducer,
  classtivityScheduler: classtivitySchedulerReducer,
  classDetailTable: classDetailTableReducer,
  entities: entityReducer,
  excessInventory: excessInventoryReducer,
  form: formReducer,
  instructors: instructorsReducer,
  localeData: localeReducer,
  modal: modalReducer,
  opportunitiesTeaser: opportunitiesTeaserReducer,
  optimizely: optimizelyReducer,
  pike13: pike13MigrationReducer,
  ratings: ratingsReducer,
  reportsReservations: reservationsReportReducer,
  payoutTransaction: payoutTransactionReducer,
  reportsSchedule: scheduleReportReducer,
  reportsSchedules: schedulesReportReducer,
  reportsVenues: venuesReportReducer,
  route: routeReducer,
  schedules: schedulesReducer,
  sidenav: sidenavReducer,
  snackbar: snackbarReducer,
  stats: statsReducer,
  venuePage: venuePageReducer,
  ui: uiReducer,
  yieldManagement: yieldManagementReducer,
});

export default rootReducer;
